import {
  Button, Divider, Flex, Select, Typography,
} from 'antd';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { DAYS } from 'constants';
import { ModifierContext } from '../../../../context';
import { getWorkingHoursByDay } from '../utils';
import WorkingDay from './WorkingDay';

function CopyHoursBar({ workingDays, onChangeDetail }) {
  const [selectedDay, setSelectedDay] = useState(null);

  const handleCopyToAllDays = () => {
    if (!selectedDay) return;
    const sourceDay = workingDays.find((d) => d.key === selectedDay);
    if (!sourceDay) return;

    const newWorkingDays = workingDays.map((d) => {
      if (d.key === selectedDay) return d;
      return {
        ...d,
        isClosed: sourceDay.isClosed,
        activeTimes: sourceDay.activeTimes.map(({ from, to }) => ({
          from: from && (dayjs.isDayjs(from) ? from.clone() : dayjs(from)) || from,
          to: to && (dayjs.isDayjs(to) ? to.clone() : dayjs(to)) || to,
        })),
      };
    });
    onChangeDetail('workingDays', newWorkingDays);
  };

  return (
    <Flex wrap="wrap" gap="small" align="center">
      <Select
        placeholder="Select day to copy from"
        value={selectedDay}
        onChange={setSelectedDay}
        style={{ minWidth: 180 }}
        options={Object.entries(DAYS).map(([key, label]) => ({ value: key, label }))}
      />
      <Button type="primary" onClick={handleCopyToAllDays} disabled={!selectedDay}>
        Copy to all days
      </Button>
    </Flex>
  );
}

function ActiveHours({ detail, onChangeDetail }) {
  const { merchant } = useContext(ModifierContext);
  const [parentActiveHours, setParentActive] = useState([]);
  useEffect(() => {
    setParentActive(merchant?.parent?.active_hours);
  }, [merchant]);

  const changeTimeSlot = ({ weekday, index, value }) => {
    const changedData = [...detail.workingDays];
    const currentDayIndex = changedData.findIndex((d) => d.key === weekday);
    changedData[currentDayIndex].activeTimes[index] = { from: value[0], to: value[1] };
    onChangeDetail('workingDays', changedData);
  };

  const addTimeSlot = ({ weekday }) => {
    const changedData = [...detail.workingDays];
    const currentDayIndex = changedData.findIndex((d) => d.key === weekday);
    changedData[currentDayIndex].activeTimes = [...changedData[currentDayIndex].activeTimes, { from: '', to: '' }];
    onChangeDetail('workingDays', changedData);
  };

  const removeTimeSlot = ({ weekday, index }) => {
    const changedData = [...detail.workingDays];
    const currentDayIndex = changedData.findIndex((d) => d.key === weekday);
    changedData[currentDayIndex].activeTimes.splice(index, 1);
    onChangeDetail('workingDays', changedData);
  };

  const onChangeDayAvailability = ({ value, weekday }) => {
    onChangeDetail('workingDays', detail.workingDays.map((d) => (d.key === weekday ? {
      ...d,
      isClosed: value,
    } : d)));
  };

  const getParentHours = (weekday) => {
    const hours = getWorkingHoursByDay({ weekday, details: parentActiveHours });
    return hours.map((h) => `${hours[0].from.format('HH:mm A')} - ${hours[0].to.format('HH:mm A')}`);
  };

  return (
    <>
      <Typography.Title level={5}>Active hours</Typography.Title>
      <Flex vertical gap="middle">
        <CopyHoursBar workingDays={detail.workingDays} onChangeDetail={onChangeDetail} />
        {detail.workingDays.map((weekDay, index) => (
          <>
            <WorkingDay
              key={weekDay.key}
              weekday={weekDay}
              changeTimeSlot={changeTimeSlot}
              addTimeSlot={addTimeSlot}
              removeTimeSlot={removeTimeSlot}
              onChangeAvailability={onChangeDayAvailability}
              parentHours={getParentHours(weekDay.key)}
            />
            {index < detail.workingDays.length - 1 && <Divider style={{ margin: 0 }} />}
          </>
        ))}
      </Flex>
    </>
  );
}

export default ActiveHours;
